var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v(" Emailer Dashboard ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-danger text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.Allocated <= 0
    }, 'text-danger'],
    staticStyle: {
      "color": "#3c8289"
    },
    attrs: {
      "target": "_self",
      "title": "Allocated Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'Allocated'
        }
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.emailStatus.Allocated) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-danger text-center mb-0 mt-2"
  }, [_vm._v("Allocated")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(As Of Now)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.InProcess <= 0
    }, 'text-primary'],
    staticStyle: {
      "color": "#fea223"
    },
    attrs: {
      "target": "_self",
      "title": "InProcess Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'InProcess'
        }
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.emailStatus.InProcess) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("InProcess")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(As Of Now)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-success text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.Close <= 0
    }, 'text-success'],
    staticStyle: {
      "color": "#86ad47"
    },
    attrs: {
      "target": "_self",
      "title": "Closed Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'Close'
        }
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.emailStatus.Close) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-success text-center mb-0 mt-2"
  }, [_vm._v("Closed")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-secondary text-center mb-0 mt-2"
  }, [_c('router-link', {
    class: [{
      'click-not-allowed': _vm.emailStatus.Spam <= 0
    }, 'text-secondary'],
    staticStyle: {
      "color": "#e04b4a"
    },
    attrs: {
      "target": "_self",
      "title": "Spam Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'Spam'
        }
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.emailStatus.Spam) + "\n                  ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-secondary text-center mb-0 mt-2"
  }, [_vm._v("Spam")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted font-weight-bold text-center font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('b-card', {
    attrs: {
      "no-block": ""
    }
  }, [_c('div', {
    staticClass: "h5 text-primary text-center mb-0 mt-2"
  }, [_c('router-link', {
    staticClass: "has-text-black-bis",
    class: [{
      'click-not-allowed': _vm.emailStatus.FollowUp <= 0
    }, 'text-primary'],
    attrs: {
      "target": "_self",
      "title": "Follow Up Cases",
      "to": {
        path: '/emailtracking',
        query: {
          status: 'followup',
          tlemail: _vm.filter.tlemailid
        }
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.emailStatus.FollowUp) + "\n                      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "h6 text-primary text-center mb-0 mt-2"
  }, [_vm._v("Follow Up")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted text-center font-weight-bold font-xs"
  }, [_c('small', [_vm._v("(Today)")])])])], 1)])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0177b241","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/emailr/agentdashboard.vue
// module id = 896
// module chunks = 1